(function ($) {
	$.fn.footer = function () {
		let $el = this;

		const init = function () {
			load();

			$(window).bind('resize scroll', function () {
				load();
			});
		};

		const load = function () {
			const footerHeight = $el.find('.footer--inner').outerHeight();
			// resize footer element to its content size
			$el.height(footerHeight);
			// fix footer to bottom of the page AFTER getting the height of the content
			$el.find('.footer--inner').css('position', 'fixed');
			// once #page is off the screen, unfix it
			const windowHeight = $(window).height();

			// Check if the component is within 40px of the current viewport
			const visible =
				document.getElementById('page').getBoundingClientRect().bottom +
					windowHeight <
				windowHeight;

			// If the component is visible, calculate the new position
			if (visible) {
				$el.find('.footer--inner').css('position', 'relative');
			}
		};

		if (this.length > 0) {
			if (this.length > 1) {
				this.each(function () {
					$(this).footer();
				});
			} else {
				$el = this;
				init();
			}
		}
	};

	$(document).ready(function () {
		$('.footer').footer();
	});
})(jQuery);
